import { Injectable } from "@angular/core";
import { RegbpService } from "../api/src/app/services/regbp.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Dossier } from '../api/src/app/models/REGBP-V1.0.0/dossier.model';
import { DossierDetails } from '../api/src/app/models/REGBP-V1.0.0/dossier-details.model';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class DossierFacade {

  constructor(public regbpService: RegbpService, private store: Store) {}

  public getDossierList(lang: string): Observable<Dossier[]> {
    return this.regbpService.getDossierList(lang).pipe(
      map((results: any) => results.$response.body.values)
    );

  }

  public getDossierDetails(dossierCode: string, language: string, auth_mime?: string, nrn_mime?: string): Observable<DossierDetails> {
    return this.regbpService.getDossierDetails(dossierCode, language, auth_mime, nrn_mime).pipe(
      map((results: any) => results.$response.body.values[0])
    );

  }
}


/*const mockDossier = DossierDetails.mergeJSON(new DossierDetails(), {
  'dossierCode': 'VGWB-abc123',
  'name': 'Vermeulen',
  'firstName': 'Joske',
  'dossierId': 'abc123',
  'dossierClassification': 'W',
  'status': 'OP',
  'approvedEvolutions': [
    {
      'dossierId': 'abc123',
      'evolutionDescriptionCode': 'descCode',
      'courtOfJustice': 'Vredegerecht Willebroek',
      'repertoireCode': 'repertoireCode',
      'numberYear': '3124/2020',
      'approvedDate': '2020-03-12T10:18:13+01:00'
    }
  ],
  'futureEvolutions': [
    {
      'dossierCode': 'VGWB-abc123',
      'dossierId': 'abc123',
      'evolutionDescriptionCode': 'descCode',
      'toDeposeDate': '2020-03-19T15:57:13+01:00',
      'toHandleDate': '2020-03-21T15:57:13+01:00',
      'courtOfJustice': 'Vredegerecht Willebroek',
      'partyName': 'Jef Vernimmen',
      'partyType': 'GA'
    }
  ],
  'draftEvolutions': [
    {
      'dossierCode': 'VGWB-abc123',
      'dossierId': 'abc123',
      'evolutionDescriptionCode': 'descCode',
      'toDeposeDate': '2020-03-19T15:57:13+01:00',
      'toHandleDate': '2020-03-21T15:57:13+01:00',
      'courtOfJustice': 'Vredegerecht Willebroek',
      'lastModificationDate': '2020-03-13T15:57:13+01:00',
      'depositionDate': '2020-03-17T15:57:13+01:00'
    }
  ],
  'reviewEvolutions': [
    {
      'dossierCode': 'VGWB-abc123',
      'dossierId': 'abc123',
      'evolutionDescriptionCode': 'descCode',
      'depositionDate': '2020-03-17T15:57:13+01:00',
      'toHandleDate': '2020-03-21T15:57:13+01:00',
      'courtOfJustice': 'Vredegerecht Willebroek'
    }
  ],
  'personCapacities': [
    {
      'code': 'P1',
      'capable': false,
      'aid': 'REPRES'
    },

    {
      'code': 'P2',
      'capable': true,
      'aid': null
    },

    {
      'code': 'P5',
      'capable': false,
      'aid': 'COUNSEL'
    },
  ],
  'goodsCapacities': [
    {
      'code': 'G1',
      'capable': false,
      'aid': 'REPRES'
    }
   ],
  'parties': [
    {
      'partyType': 'PP',
      'firstName': 'Jos',
      'name': 'Potargent',
      'streetNumber': 'Somestreet 5',
      'postalCode': '2550',
      'city': 'Kontich',
      'email': 'jos@email.corp',
      'phoneNumber': '+32 3 123 45 67',
      'mobileNumber': '+32 496 23 45 69'
    },
    {
      'partyType': 'GA',
      'firstName': 'Jef',
      'name': 'Vernimmen',
      'streetNumber': 'Anotherstreet 5',
      'postalCode': '2550',
      'city': 'Kontich',
      'email': 'jef@email.corp',
      'phoneNumber': '+32 3 123 45 67',
      'mobileNumber': '+32 496 23 45 69'
    },
    {
      'partyType': 'RQ',
      'firstName': 'Louis',
      'name': 'Denaanvrager',
      'streetNumber': 'Thirdstreet 5',
      'postalCode': '2650',
      'city': 'Edegem',
      'email': 'louis@email.corp',
      'phoneNumber': '+32 3 123 45 67',
      'mobileNumber': '+32 496 23 45 69'
    }

  ],

  'subDossiers': [ ]

});

const mockDossierList = Dossier.mergeJSON(new Dossier(), {
  'name': 'Vermeulen',
  'firstName': 'Joske',
  'dossierId': 'abc123',
  'dossierCode': 'VGWB-abc123',
  'dossierClassification': 'W'
});*/

